/* eslint-disable max-len */
import { FuseNavigationItem } from "@fuse/components/navigation";

export const navigation = (
  badgeMap: Record<string, string>,
  currentAccount: any,
  isFlagOn: (key: string, def?: boolean) => boolean = () => true
): FuseNavigationItem[] => {
  const navigationMenu: FuseNavigationItem[] = [
    // {
    //   id: "main",
    //   title: "",
    //   type: "group",
    // children: [
    {
      id: "dashboard",
      title: "shell.nav.dashboard",
      type: "basic",
      icon: "taskezy:te_web_dashboard",
      link: "/pages/home"
    },
    //   ]
    // },
    {
      id: "network",
      title: "shell.nav.network",
      type: "group",
      children: [
        {
          id: "clients",
          title: "shell.nav.clients",
          icon: "taskezy:te_web_clients",
          type: "basic",
          link: "/pages/list-clients",
          ...(badgeMap["clients"] && badgeMap["clients"] !== "0"
            ? {
                badge: {
                  title: badgeMap["clients"],
                  classes: "w-5 h-5 bg-primary text-white rounded-full"
                }
              }
            : {}),
          hidden: () =>
            !currentAccount?.isSubscriber && !currentAccount?.isSupplier
        },
        {
          id: "list-venues",
          title: "shell.nav.venues",
          icon: "taskezy:te_web_venue",
          type: "basic",
          link: "/pages/list-venues",
          hidden: () => false //We decided to always show venues because there's currently no
          // universal way to accurately determine whether an account is a client or a supplier.
          // This issue remains relevant.
        },
        {
          id: "suppliers",
          title: "shell.nav.suppliers",
          icon: "taskezy:te_web_supplier",
          type: "basic",
          link: "/pages/list-suppliers",
          ...(badgeMap["suppliers"] && badgeMap["suppliers"] !== "0"
            ? {
                badge: {
                  title: badgeMap["suppliers"],
                  classes: "w-5 h-5 bg-primary text-white rounded-full"
                }
              }
            : {}),
          hidden: () =>
            currentAccount?.isSubscriber || currentAccount?.isClient
              ? false
              : true
        },
        {
          id: "resources",
          title: "shell.nav.resources",
          icon: "taskezy:te_web_resource",
          type: "basic",
          link: "/pages/list-resources",
          ...(badgeMap["resources"] && badgeMap["resources"] !== "0"
            ? {
                badge: {
                  title: badgeMap["resources"],
                  classes: "w-5 h-5 bg-primary text-white rounded-full"
                }
              }
            : {})
          // hidden: () => currentAccount?.isSubscriber || currentAccount?.isSupplier ? false : true
        }
      ]
    },
    {
      id: "activities",
      title: "shell.nav.activities",
      type: "group",
      children: [
        {
          id: "roster",
          title: "shell.nav.roster",
          type: "basic",
          icon: "taskezy:te_web_roster",
          link: "/pages/roster",
          ...(badgeMap["roster"] && badgeMap["roster"] !== "0"
            ? {
                badge: {
                  title: badgeMap["roster"],
                  classes: "w-5 h-5 bg-primary text-white rounded-full"
                }
              }
            : {})
        },
        {
          id: "attendance-register",
          title: "shell.nav.attendanceRegister",
          type: "basic",
          icon: "taskezy:te_web_attendance",
          link: "/pages/attendance-register",
          hidden: () => (currentAccount?.isSubscriber ? false : true)
        },
        {
          id: "register",
          title: "shell.nav.timesheetRegister",
          type: "basic",
          icon: "taskezy:te_web_timesheet-register",
          link: "/pages/timesheet-register",
          ...(badgeMap["timesheet-register"] &&
          badgeMap["timesheet-register"] !== "0"
            ? {
                badge: {
                  title: badgeMap["timesheet-register"],
                  classes: "w-5 h-5 bg-primary text-white rounded-full"
                }
              }
            : {}),
          hidden: () => (currentAccount?.isSubscriber ? false : true)
        },
        {
          id: "reporting",
          title: "shell.nav.incidentReporting",
          type: "basic",
          icon: "taskezy:",
          link: "/pages/",
          hidden: () => true
        },
        {
          id: "interviews-onboarding",
          title: "shell.nav.interviewsOnboarding",
          type: "basic",
          icon: "taskezy:",
          link: "/pages/",
          hidden: () => true
        },
        {
          id: "performance-management",
          title: "shell.nav.performanceManagement",
          type: "basic",
          icon: "taskezy:",
          link: "/pages/",
          hidden: () => true
        },
        {
          id: "template-library",
          title: "shell.nav.templateLibrary",
          type: "basic",
          icon: "taskezy:",
          link: "/pages/",
          hidden: () => true
        }
      ]
    },
    {
      id: "reports",
      title: "shell.nav.reports",
      type: "group",
      children: [
        {
          id: "sign-on-off-registers",
          title: "shell.nav.signOnOffRegisters",
          type: "basic",
          icon: "taskezy:te_web_timesheet-register",
          link: "/pages/sign-on-sign-off-register"
        },
        {
          id: "incident-reports",
          title: "shell.nav.incidentReports",
          type: "basic",
          icon: "taskezy:te_web_incident-report",
          link: "/pages/incident-reporting",
          ...(badgeMap["incident-reports"] &&
          badgeMap["incident-reports"] !== "0"
            ? {
                badge: {
                  title: badgeMap["incident-reports"],
                  classes: "w-5 h-5 bg-primary text-white rounded-full"
                }
              }
            : {})
        },
        {
          id: "assessments",
          title: "shell.nav.assessments",
          type: "basic",
          icon: "taskezy:",
          link: "/pages/",
          hidden: () => true
        },
        {
          id: "end-of-shift-reports",
          title: "shell.nav.endOfShiftReports",
          type: "basic",
          icon: "taskezy:",
          link: "/pages/",
          hidden: () => true
        },
        {
          id: "other-custom-reports",
          title: "shell.nav.otherCustomReports",
          type: "basic",
          icon: "taskezy:",
          link: "/pages/",
          hidden: () => true
        }
      ]
    },
    // {
    //   id       : 'templates',
    //   title    : 'TEMPLATES',
    //   type     : 'group',
    //   children : [
    //     {
    //       id             : 'interviews',
    //       title          : 'Interviews',
    //       type           : 'basic',
    //       icon           : 'taskezy:te_web_Interviews',
    //       link            : '/pages/interviews',
    //     },
    //     // {
    //     //   id:  'forms',
    //     //   title: 'Forms',
    //     //   icon: 'business_center',
    //     //   type: 'basic',
    //     //   link: '/pages/forms'
    //     // },
    //   ]
    // },
    {
      id: "account",
      title: "shell.nav.account",
      type: "group",
      children: [
        {
          id: "details",
          title: "shell.nav.details",
          type: "basic",
          icon: "taskezy:te_web_Details",
          link: "/pages/details",
          ...(badgeMap["account-details"] && badgeMap["account-details"] !== "0"
            ? {
                badge: {
                  title: badgeMap["account-details"],
                  classes: "w-5 h-5 bg-primary text-white rounded-full"
                }
              }
            : {})
        },
        {
          id: "members",
          title: "shell.nav.members",
          type: "basic",
          icon: "taskezy:te_web_members",
          link: "/pages/list-members"
        },
        {
          id: "asset-library",
          title: "shell.nav.assetLibrary",
          type: "basic",
          icon: "taskezy:te_web_asset_library",
          link: "/pages/asset-library",
          hidden: () => !isFlagOn("accreditations-available", false)
        },
        {
          id: "accreditation-register",
          title: "shell.nav.accreditations",
          type: "basic",
          icon: "taskezy:te_web_asset_library",
          link: "/pages/accreditation-v2/register",
        },
        {
          id: "compliance-eligibility",
          title: "shell.nav.complianceSuite",
          type: "basic",
          icon: "verified_user",
          link: "/pages/compliance-eligibility",
          // hidden: () => !isFlagOn("compliance-suite-available", false)
        },
        {
          id: "audit-log",
          title: "shell.nav.logs",
          type: "basic",
          icon: "taskezy:te_web_logs",
          link: "/pages/audit-log",
          hidden: () => !isFlagOn("disable_not_complete", false)
        }
        //   ]
        // },
        // {
        // id       : 'others',
        // type     : 'group',
        // children : [
        // {
        //   id             : 'swap-profile',
        //   title          : 'Swap Profile',
        //   type           : 'basic',
        //   icon           : 'swap_horiz',
        //   link            : '/pages/my-profiles'
        // },
        // {
        //    id            : 'resource-pool',
        //    title         : 'Resource Pool',
        //    type          : 'basic',
        //    icon          : 'assignment_ind',
        //    link          : '/pages/resource-pool'
        // }
      ]
    }
  ];
  return navigationMenu;
};
